import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';

import { HeartIcon, ClipboardCopyIcon, SunIcon, ArrowLeftIcon } from '@heroicons/react/outline'

//image
import defaultPng from '../../../../../../../../images/default.png'

const ProfileCard = ({user, id, liked, savedResults, dailyResults, setProjects, setResult}) => {

    const [ red, setRed ] = useState("h-12 w-12 border border-gray-300 bg-white text-gray-300 hover:bg-red-500")
    const [ green, setGreen ] = useState("h-12 w-12 border border-gray-300 bg-white text-gray-300 hover:bg-green-500")
    const [ yellow, setYellow ] = useState("h-12 w-12 border border-gray-300 bg-white text-gray-300 hover:bg-yellow-500")

    return (
      <div className="flex ">
        <div className="mr-4 flex-shrink-0">
          <img 
          style={{borderRadius:'20px'}}
          src={defaultPng} 
          alt='profilePng' 
          className="h-16 w-16 border border-gray-300 bg-white text-gray-300"
          />
        </div>
        <div >
            <h4 className="text-lg font-bold">{user?.firstName} {user?.lastName}</h4>
            <p className="text-sm text-gray-500 truncate">{user?.company}</p>
            <p className="text-sm text-gray-500 truncate">{id}</p>

          <div className="mt-6 flex flex-wrap">
            <div className="mr-2 flex-shrink-0" style={{marginLeft: '-20px'}}>
              <HeartIcon 
              style={{borderRadius:'10px'}} 
              className={red} //"h-12 w-12 border border-gray-300 bg-white text-gray-300 bg-red-700" 
              aria-hidden="true" 
              onClick={()=>{
                  setProjects(liked); 
                  setRed("h-12 w-12 border border-gray-300 bg-white text-gray-300 bg-red-500");
                  setGreen("h-12 w-12 border border-gray-300 bg-white text-gray-300");
                  setYellow("h-12 w-12 border border-gray-300 bg-white text-gray-300");
                  setResult(false)
                }} 
              />
            </div>
            <div>
              <h4 className="text-lg font-bold mr-6">Liked messages</h4>
              <p className="mt-1">
                Total messages: {liked?.length}
              </p>
            </div>
            <div className="mr-2 flex-shrink-0" style={{marginLeft: '-20px'}}>
              <ClipboardCopyIcon 
              style={{borderRadius:'10px'}} 
              className={green}
              aria-hidden="true" 
              onClick={()=>{
                setProjects(savedResults); 
                setRed("h-12 w-12 border border-gray-300 bg-white text-gray-300");
                setGreen("h-12 w-12 border border-gray-300 bg-white text-gray-300 bg-green-500");
                setYellow("h-12 w-12 border border-gray-300 bg-white text-gray-300");
                setResult(false);
              }} 
              />
            </div>
            <div>
              <h4 className="text-lg font-bold mr-6">Copied messages</h4>
              <p className="mt-1">
                Total messages: {savedResults?.length}
              </p>
            </div>
            <div className="mr-2 flex-shrink-0" style={{marginLeft: '-20px'}}>
              <SunIcon 
              style={{borderRadius:'10px'}} 
              className={yellow}
              aria-hidden="true" 
              onClick={()=>{
                setProjects(dailyResults); 
                setRed("h-12 w-12 border border-gray-300 bg-white text-gray-300");
                setGreen("h-12 w-12 border border-gray-300 bg-white text-gray-300 ");
                setYellow("h-12 w-12 border border-gray-300 bg-white text-gray-300 bg-yellow-500");
                setResult(false)
              }} 
              />
            </div>
            <div>
              <h4 className="text-lg font-bold">Daily messages</h4>
              <p className="mt-1">
                Total messages: {dailyResults?.length}
              </p>
            </div>
          </div>
        </div>
          <div className="-ml-7 flex-shrink-0" >
            <NavLink
            exact
            to={'/usersBound'}
            >
              <button
                type="button"
                className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <ArrowLeftIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
                Return
              </button>
            </NavLink>
          </div>
      </div>
    )
}

export default ProfileCard